module.exports = __webpack_public_path__ + "img/oilsheep.9c4562ec.png";